// extracted by mini-css-extract-plugin
var _1 = "BottomSpacing-Pw6_V";
var _2 = "SectionTitle-RmaqM";
export { _1 as "BottomSpacing", _2 as "SectionTitle" }
